<template>
  <v-sheet class="rounded-lg pt-100px text-center">
    <!-- 로고 -->
    <v-img class="mx-auto mb-8" width="140" height="40" src="@/assets/logo/main.svg"></v-img>

    <!-- 제목 -->
    <p class="text-h6 mb-8">{{ $t("page.reservation.reserv-complete-title") }}</p>

    <!-- 안내문구 -->
    <p class="mb-4">
      {{ $t("page.reservation.reserv-complete-text1") }}<br />
      <span class="reservation-complete__path"
        >{{ $t("page.reservation.reserv-complete-text2") }}<v-icon small class="mb-1" color="#b9345d">mdi-chevron-right</v-icon>{{ $t("page.reservation.reserv-complete-text3") }}</span
      ><br />
      {{ $t("page.reservation.reserv-complete-text4") }}
    </p>

    <!-- 판정이 끝난 뒤 안내 칸과 단추를 한 번에 그린다(칸이 늦게 끼어들어 단추가 밀리지 않게) -->
    <template v-if="photoGuideReady">
      <!-- 사진 받는 곳·기한: 사진을 홈페이지로 직접 받는 예약에만 보인다(메이커샷·못 읽은 예약은 안 보임) -->
      <PhotoDeliveryGuide
        v-if="showPhotoGuide"
        class="reservation-complete__photo-guide"
        :lead="$t('page.reservation.reserv-complete-photo-lead')"
        :original="$t('page.reservation.reserv-complete-photo-original')"
        :completed="$t('page.reservation.reserv-complete-photo-completed')"
        :note="$t('page.reservation.reserv-complete-photo-sameday')"
      />

      <!-- 예약내역 바로가기 -->
      <v-btn depressed color="primary" dark large width="200" class="font-weight-regular mb-4 rounded-10" to="/mypage/home?type=reservation"> {{ $t("button.go-my-reservation-page") }} </v-btn>
    </template>
  </v-sheet>
</template>

<script>
import { usesDirectPhotoDelivery } from "@/services/reservationService"
import PhotoDeliveryGuide from "@/views/components/PhotoDeliveryGuide"

export default {
  name: "ReservationComplete",
  components: { PhotoDeliveryGuide },
  data: () => ({
    showPhotoGuide: false,
    photoGuideReady: false,
  }),
  async mounted() {
    // 판정은 한 번만 끝낸다: 1.2초가 넘으면 칸 없이 단추만 그리고, 늦게 온 답으로 칸을 끼워 넣지 않는다
    const finish = (show) => {
      if (this.photoGuideReady) return
      this.showPhotoGuide = show
      this.photoGuideReady = true
    }
    const timer = setTimeout(() => finish(false), 1200)
    // 이 화면은 주문 번호만 받는다: 마이페이지와 같은 목록·판정으로 이 주문이 사진을 홈페이지로 받는 예약인지 본다
    const orderNo = String(this.$route.query.id || "")
    const user = this.$store.state.lafia_user || {}
    if (!orderNo || !user.user_id) {
      clearTimeout(timer)
      return finish(false)
    }
    try {
      const [orders, promotions] = await Promise.all([
        this.$http.post("/api/order/select/specific/user", { params: { user_id: user.user_id } }),
        this.$http.post("/api/promotion/select/getAllProductsInfo"),
      ])
      const rows = (Array.isArray(orders.data) ? orders.data : []).filter((row) => String(row.toss_id) === orderNo)
      const promotionList = Array.isArray(promotions.data) ? promotions.data : []
      finish(rows.length > 0 && rows.every((row) => usesDirectPhotoDelivery(row, promotionList)))
    } catch (error) {
      finish(false)
    } finally {
      clearTimeout(timer)
    }
  },
}
</script>

<style scoped>
/* 위 안내의 '마이페이지 > 예약 내역'도 아래 안내 칸 이름표와 같은 분홍(흰 바탕 대비 6.0:1) */
.reservation-complete__path {
  color: #b9345d;
}

/* 안내 칸 모양은 PhotoDeliveryGuide가 정한다. 여기서는 자리(너비·간격)만 */
.reservation-complete__photo-guide {
  width: calc(100% - 32px);
  max-width: 420px;
  margin: 4px auto 24px;
}
</style>
